import React from "react";
import OrganizationCard from "components/OrganizationCard";
import Card from "components/Card/Card";
import OrganizationDetails from "components/OrganizationDetails";
import { OrganizationTable } from "components/Tables";

export function RenderOrganization(org, fetchAllApiData) {
  const orgLocal = org;

  return (
    <OrganizationCard
      title={orgLocal.title}
      organization={org}
      fetchAllApiData={fetchAllApiData}
      // isLocked={orgLocal.is_blocked ? "true" : "false"}
      isLocked={!!orgLocal.is_blocked}
      border={orgLocal.is_blocked ? "locked-border-bottom" : "border-bottom"}
      bodyStyle={
        orgLocal.is_blocked
          ? "b-organization-container__locked-headingBody"
          : "b-organization-container__headingBody"
      }
      body={
        <OrganizationDetails
          organization={org}
          fetchAllApiData={fetchAllApiData}
        />
      }
    />
  );
}

export function RenderOrganizationInTable(org, lockedTable) {
  const isLocked = lockedTable === "true";
  if (isLocked) {
    return (
      <Card
        title="Locked Organizations"
        isLocked
        body={<OrganizationTable organization={org} isExport={false} />}
      />
    );
  }
  return (
    <Card
      title="Index of Organizations"
      isLocked={false}
      body={<OrganizationTable organization={org} isExport={false} />}
    />
  );
}
